<template>
  <div class="finish-picker" v-if="product">
    <div class="finish-main-header">
      <h2 class="finish-main-title">Finishes</h2>
      <img class="finish-arrow" src="@/assets/img/arrow_down.svg" alt="" />
    </div>
    <div v-for="(type, index) of product.acf['acf-single-product-options-finish-repeater-section']" :key="`product-${index}`" class="finish-type">
      <h2>{{type['acf-single-product-options-finish-repeater-section-title']}}</h2>
      <p class="mb-10 text-[18px]" v-if="type['acf-single-product-options-finish-repeater-section-description']">{{ type['acf-single-product-options-finish-repeater-section-description'] }}</p>
      <div class="texture-card-container" :class="gridCols(type['acf-single-product-options-finish-repeater']?.length || 0)">
        <FinishSelectorCard v-for="(material, idx) of type['acf-single-product-options-finish-repeater']" :material="material" :finishname="type['acf-single-product-options-finish-repeater-section-title']" :key="`material-${idx}`" />
      </div>
    </div>
  </div>
</template>
<script setup>
import { ProductState } from './state'
import FinishSelectorCard from './FinishSelectorCard.vue'
const { product } = ProductState()

const gridCols = (count) => {
  if (count <= 2) return 'cols-2'
  if (count === 4) return 'cols-2'
  if (count % 3 === 2) return 'cols-3-fill'
  return 'cols-3'
}
</script>
<style lang="scss" scoped>
  .finish-picker {
    @apply ml-0 lg:ml-28;
    .finish-main-header {
      @apply flex items-center gap-4 mt-8 mb-4;
      .finish-main-title {
        @apply text-[28px] md:text-[32px] text-ore_green_dark;
      }
      .finish-arrow {
        @apply w-5 h-5 md:w-6 md:h-6;
      }
    }
    .finish-type {
      @apply bg-[#D9E5DD] rounded-2xl p-6 lg:p-8 mt-6 shadow-md;
      h2 {
        @apply text-[20px] text-ore_green_dark mb-4;
      }
      .texture-card-container {
        @apply grid grid-cols-2 gap-3;
        &.cols-3 { @apply lg:grid-cols-3; }
        &.cols-3-fill {
          @media (min-width: 1024px) {
            grid-template-columns: repeat(6, 1fr);
            & > :deep(*) { grid-column: span 2; }
            & > :deep(*:last-child:nth-child(3n+2)) { grid-column: span 3; }
            & > :deep(*:nth-last-child(2):nth-child(3n+1)) { grid-column: span 3; }
          }
        }
      }
    }
  }
</style>
